import { Box, useMediaQuery, useTheme } from "@mui/material"
import {
    KeyboardDoubleArrowDown as KeyboardDoubleArrowDownIcon,
    KeyboardDoubleArrowUp as KeyboardDoubleArrowUpIcon
} from "@mui/icons-material";

import { IconButton, Textfield, Typography } from "@initia-digital/component-library"

import { SectionHeader } from "./SectionHeader"
import { useWorkAndSafetyStore } from "../store";



export const WorkingWithOthers = () => {
    // ------------------------------------
    const {
        editPrestartState, updateEditPrestartState
    } = useWorkAndSafetyStore();
    const {
        teamWorkDetail
    } = editPrestartState;

    const theme = useTheme();
    const isSmallerThanSm = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            id="working-with-others"
            display="flex" flexDirection="column"
            border={isSmallerThanSm ? "none" : "1px solid lightgrey"}
            borderTop={`1px solid ${theme.palette.secondary.main}`} borderRadius={isSmallerThanSm ? "none" : "5px"}
            pb="20px" px={isSmallerThanSm ? '10px' : '20px'}
            mt={isSmallerThanSm ? '20px' : '0px'} pt={isSmallerThanSm ? '20px' : '0px'}
        >
            <Box display="flex" flexDirection="row" alignItems="center">
                <SectionHeader label="4. Working with others" />
                <Box display="flex" flexDirection="row" justifyContent="flex-end">
                    <Box mr="10px">
                        <IconButton
                            size="vsmall"
                            onClick={() => window.location.hash = '#closure-and-contacts'}
                            tooltipTitle={`Go to Closure and Contacts`}
                            color={theme.palette.secondary.contrastText}
                            backgroundColor={theme.palette.secondary.main}
                            hoverColor={theme.palette.primary.main}
                            hoverBackgroundColor={theme.palette.primary.contrastText}
                        >
                            <KeyboardDoubleArrowDownIcon />
                        </IconButton>
                    </Box>
                    <Box mr="10px">
                        <IconButton
                            size="vsmall"
                            onClick={() => window.location.hash = '#hazard-observations'}
                            tooltipTitle={`Go to Hazard Observations`}
                            color={theme.palette.secondary.contrastText}
                            backgroundColor={theme.palette.secondary.main}
                            hoverColor={theme.palette.primary.main}
                            hoverBackgroundColor={theme.palette.primary.contrastText}
                        >
                            <KeyboardDoubleArrowUpIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
            <Box
                display="flex" flexDirection="row" gap={1} alignItems="center"
            >
                <Typography
                    fontSize="0.9rem"
                    fontWeight={700}
                    color={theme.palette.primary.contrastText}
                >
                    {`Overlapping duties`}
                </Typography>
            </Box>
            <Box my="4px">
                <Textfield
                    value={teamWorkDetail}
                    name="teamWorkDetail"
                    minRows={3}
                    label="Describe any overlapping duties and record how you will work together"
                    placeholder="Describe any overlapping duties and record how you will work together"
                    handleChange={(event) => {
                        // ---------------------
                        updateEditPrestartState({
                            ...editPrestartState,
                            teamWorkDetail: event.target.value
                        });
                    }}
                />
            </Box>
        </Box>
    )
}